import Vue from 'vue'
import convert from '@/utils/convert.js'
const defaultColor = {
  0: 'gray',
  1: 'green',
  2: 'red'
}
// 用于图标转换的指令 本质上还是调用convert.js  只是减少了函数的引入与添加到data的操作

// 颜色转换
const color = {
  // 主题色
  theme: 'var(--primary-color)',
  // 灰色
  gray: '#ccc'
}

// v-icon 提供一个数组
// 例 v-icon:theme="['carrierStatusConvert',1]"

/**
 * value[0]函数名
 * value[1]函数的参数
 * */
Vue.directive('icon', {
  bind: (el, binding, vnode) => {
    setIcon(el, binding, vnode)
  },
  update (el, binding, vnode) {
    setIcon(el, binding, vnode)
  }
})

function changeColor (param, color = '') {
  // 不推荐使用typeof
  let str
  const colorObj = Object.prototype.toString.call(color) === '[object Object]' ? color : defaultColor
  for (const key in colorObj) {
    if (key === String(param)) {
      str = colorObj[key]
      break
    }
  }
  return `color:${str};`
}

function setIcon (el, binding, vnode) {
  const { value, arg } = binding
  if (value instanceof Array) {
    const fn = convert[value[0]]
    const param = value[1]
    // 未在convert.js内找到该函数则返回
    if (!fn) return

    // 做兼容处理 一般图标的都有5px的margin-right 如果发现style内有则不进行设置
    if (!el.style.marginRight) el.style.marginRight = '5px'

    // 存在即证明需要改变颜色
    if (value[2]) {
      el.setAttribute('style', changeColor(param, value[2]))
    }

    // 可能不存在title和icon 这种情况标签可直接不展示
    try {
      el.setAttribute('title',  fn(param) && $t(fn(param).title))
      // 需要把原来的class加上
      const cls = el.getAttribute('class')
      el.setAttribute('class', `${fn(param) && fn(param).icon}  cursor-pointer`)
    } catch {
      el.style.display = 'none'
    }
  }
  // 这里使用行内式的写法 除非用了important 否则不会有权重问题 相当于强制设置图标颜色
  if (color[arg]) {
    el.style.color = color[arg]
  }
  // console.log(el,binding,vnode);
}
